import './CookiePopup.scss';
import FacebookMessanger from '../FacebookMessanger/FacebookMessanger';
class CookiePopup {
	constructor() {
		this.cookieName = 'cookie-info';
		this.cookieValue = '1';
		this.cookieLive = 30;
		this.init();
	}
	init() {
		var t = this;

		if( t.checkCookie(t.cookieName) != 1) {

			var requestData = new FormData();
			requestData.append('action','CookiePopup');

			fetch( window.location.origin +'/wp-admin/admin-ajax.php', {
				method: 'POST',
				body : requestData
			})
			.then(function (response) {

				let content = response.text();
				if( response.status === 200 && content ) {
					return content;
				} else {
					return '';
				}

			})
			.then( function(html) {
				if( html ) {
					t.render( html );
				} 
			})
  			.catch( function( error ) {
  				console.log("Cookie popup can't load");
  				console.log(error);
  			});

		};

	}
	render( html ) {
		var t = this;

		document.querySelector('body').insertAdjacentHTML('beforeend', html );
		var cookieContainer = document.querySelector('.CookiePopup');

		setTimeout(
			function(){ 
				cookieContainer.classList.add('active');
			}, 
			1000
		);

		cookieContainer.querySelector('.row__close').addEventListener('click', function() {
			t.setCookie( t.cookieName , t.cookieValue , 1 );
			cookieContainer.classList.remove('active');
			setTimeout(
				function(){ 
					cookieContainer.remove();
				}, 
				1000
			);
		});	

		cookieContainer.querySelector('.row__accept').addEventListener('click', function() {

			t.setCookie( t.cookieName , t.cookieValue , t.cookieLive );
			cookieContainer.classList.remove('active');

			if( document.querySelector('.FacebookMessanger') ) {
				let chatFB = new FacebookMessanger();
				chatFB.init();
			}

			setTimeout(
				function(){ 
					cookieContainer.remove();
				}, 
				1000
			);
		});
		
	}
	checkCookie( cookieName ) {
		var name = cookieName + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var ca = decodedCookie.split(';');
	    for(var i = 0; i <ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}
	setCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+ d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
}
export default CookiePopup;